import React from "react";
import { ConfigurationContractsHistoryView } from "../../views";
import { ContractService, LocalStorageService } from "../../../services/index";
import moment from "moment";
import "moment/locale/es";
import { ConservacionMensajeImage } from "../../../assets/logos/icons";

class ConfigurationContractsHistoryAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      take: 6,
      showPagination: "",
      useSignatures: "",

      contracts: [],
      expirationDate: "",
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractService = new ContractService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;

    let requests = await this.contractService.getContractsByClient(
      this.token
    );
    moment.locale("es");
    if (requests !== null) {
      requests = requests.map((contract) => {
        /*  contract.contractId = contract.id;
         let serialContract = contract.id.slice(-5).toUpperCase();
         contract.id = serialContract; */
        let dateStart = contract.createdDate.split("T")[0];
        let dataStartContract = moment(dateStart)
          .format("DD/MMM/YYYY")
          .replace(/\./g, "");
        let yearStartContract = dataStartContract.split("/")[2];
        let monthStartContract = dataStartContract.split("/")[1];
        let dayStartContract = dataStartContract.split("/")[0];
        let dateStartComplete =
          dayStartContract + "/" + monthStartContract + "/" + yearStartContract;
        contract.createdDate = dateStartComplete;
        let dateExpiration = contract.endOfContract.split("T")[0];
        let dataContract = moment(dateExpiration)
          .format("DD/MMM/YYYY")
          .replace(/\./g, "");
        let yearContract = dataContract.split("/")[2];
        let monthContract = dataContract.split("/")[1];
        let dayContract = dataContract.split("/")[0];
        let dateComplete =
          dayContract + "/" + monthContract + "/" + yearContract;
        contract.endOfContract = dateComplete;
        // let planMonth = contract.planLevel.plan.name + ' ' + contract.planLevel.monthlyTransaction
        // contract.planLevel.plan.name = planMonth

        let usedSigantures =
          contract.usedTransaction + "/" + contract.totalTransaction;
        contract.availableTransaction = usedSigantures;

        return contract;
      });

      this.setState({
        contracts: requests,
        loading: false,
      });
      this.onChangeFooterInfoPagination();
    } else {
      this.setState({
        contracts: "",
        loading: false,
      });
    }
  }

  /**
   * @author Alan Aguilar
   * @date 19-11-2020
   * @description Change the rendering of a custom footer in the grid
   * @memberof ConfigurationContractsHistoryAction
   */
  onChangeFooterInfoPagination = () => {
    let paginationInfoExist = document.querySelector(
      "#infoPaginationHistoryContracts"
    );
    if (paginationInfoExist) {
      paginationInfoExist.remove();
      this.setState({ showPagination: false });
    }

    let { contracts, take, skip } = this.state;

    let totalItemsInTable = contracts.length;
    if (contracts.length !== 0) {
      this.setState({ showPagination: { info: false } }, () => {
        let currentPage = Math.floor(skip / take) + 1;
        let totalPages = Math.ceil((totalItemsInTable || 0) / take);

        let firstItemInPage = skip + 1;
        let lastItemInPage = 0;
        if (currentPage === totalPages) {
          lastItemInPage = totalItemsInTable;
        } else {
          lastItemInPage = skip + take;
        }

        let footerPagination = document.querySelector("div[role='navigation']");
        if (footerPagination) {
          let element = document.createElement("div");
          element.id = "infoPaginationHistoryContracts";
          element.innerHTML = `<span>${firstItemInPage} - ${lastItemInPage} de ${totalItemsInTable} Contratos</span> <span style="margin-left: 30px;">${currentPage}/${totalPages}</span>`;
          element.className = "k-pager-info k-label";
          footerPagination.appendChild(element);
        }
      });
    } else {
      this.setState({ showPagination: false });
    }
  };

  /**
   * @author Lucia Alvarado
   * @description Change page in pagination of table
   * @param {Object} dataItem
   * @memberof ConfigurationContractsHistoryAction
   */
  onPageChange = (event) => {
    this.setState(
      {
        skip: event.page.skip,
        take: event.page.take,
      },
      () => {
        this.onChangeFooterInfoPagination();
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to move scroll
   * @memberof ConfigurationContractsHistoryAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  render() {

    return (
      <ConfigurationContractsHistoryView
        {...this.state}
        onPageChange={this.onPageChange}
        onChangeFooterInfoPagination={this.onChangeFooterInfoPagination}
        scrollWindow={this.scrollWindow}
      />
    );
  }
}

export { ConfigurationContractsHistoryAction as default };
